export default __webpack_public_path__ + "static/media/img1.02632018.jpg";